import {net} from "@/request/index";

// 编辑网站信息的方法
export const editWebSitInfo = (webSitInfo) => {
    // 设置参数
    let params = new URLSearchParams()
    params.append('webSitInfo', JSON.stringify(webSitInfo))
    return net.request({
        params: {},
        data: params,
        method: 'post',
        url: '/admin/edit/web/sit/info',
    })
}

// 获取网站信息的方法
export const getWebSitInfo = () => {
    // 设置参数
    let params = new URLSearchParams()
    return net.request({
        params: {},
        data: params,
        method: 'post',
        url: '/admin/get/web/sit/info',
    })
}
